import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { LocalizedLink } from '../../../LocalizedLink/LocalizedLink';

const pill = css`
  height: 32px;
  color: var(--color-black);
  background-color: transparent;
  display: flex;
  gap: var(--spacing-4);
  align-items: center;
  font: var(--font-body-m-bold);
  border: 1px solid black;
  border-radius: var(--border-radius-xl);
  cursor: pointer;
  transition: all 0.3s;
  padding-inline-start: var(--spacing-8);
  padding-inline-end: var(--spacing-12);
  text-decoration: none;

  &:hover {
    background-color: var(--color-neutral-20);
  }

  svg {
    width: var(--spacing-18);
    height: var(--spacing-18);
  }
`;

export const Link = styled(LocalizedLink)`
  ${pill}
`;

export const Button = styled.button`
  ${pill}
`;

export const FullName = styled.span`
  display: none;

  @media (min-width: 600px) {
    display: block;
  }
`;

export const Initials = styled.span`
  display: block;

  @media (min-width: 600px) {
    display: none;
  }
`;
